<template>
  <div ref="parent" class="w-full h-5 rounded-xl overflow-hidden ">
    <canvas ref="chart" class="w-full h-full"></canvas>
  </div>
</template>
<script setup lang="ts">
import { onMounted, shallowRef, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import * as echarts from 'echarts';

const getOptions = (series: echarts.BarSeriesOption[], salesLabel: string) => {
  return {
    title: {
      show: false,
      padding: 0
    },
    legend: {
      show: false
    },
    grid: {
      left: '0%', // Increase left margin to provide more space for yAxis labels
      top: '0%',
      bottom: "0%",
      right: '0%',
      containLabel: false, // This ensures that the grid area contains the labels
      borderWidth: 0,
      backgroundColor: 'red'
    },
    xAxis: {
      type: 'value',
      show: false,
      itemStyle: {
        margin: 0,
        borderWidth: 0
      }
    },
    yAxis: {
      type: 'category',
      data: [salesLabel],
      show: false,
      itemStyle: {
        margin: 0,
        borderWidth: 0
      }
    },
    series: series
  }
}

const parent = shallowRef();

const chart = shallowRef();
const myChart = shallowRef<echarts.ECharts>()

const props = defineProps<{
  series: echarts.BarSeriesOption[]
}>()

const { t } = useI18n()

watch(() => props.series, (newVal: echarts.BarSeriesOption[]) => {
  const options = getOptions(newVal, t('components.charts.sales'))
  myChart.value?.setOption(options);
})

onMounted(() => {
  myChart.value = echarts.init(chart.value);
  const options = getOptions(props.series, t('components.charts.sales'))
  myChart.value?.setOption(options);
})
</script>